import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowUp = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M18 14.12L16.1418 16L11.9935 11.7733L7.84515 16L6 14.12L11.9935 8L18 14.12Z", fill: "currentColor" }) });
const ForwardRef = forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
